export default __webpack_public_path__ + "static/media/logo-small.dac03288.svg";